import React from 'react';
import { observer } from 'mobx-react-lite';
import { ConnectionPopupsWr, WebGameColumn, WebGameColumnInner } from '@pascal/pascal-core';
import { Game } from '../../../Game/Game';
import { PopupsWrapper } from '../../../components/common/popupWrapper/wrapper';
import { isBetFair } from '../../../helpers/isBetFair';

const CenterColumn = observer(() => {
  return (
    <WebGameColumn position='center'>
      <WebGameColumnInner position='center'>
        <Game />
      </WebGameColumnInner>
      <ConnectionPopupsWr isShowReloadButton={!isBetFair()} />
      <PopupsWrapper />
    </WebGameColumn>
  );
});

export default CenterColumn;
